function setSelected(element: HTMLElement, value: string): void {
    const elInput = element.querySelector('input[value=' + value + ']');

    if (elInput instanceof HTMLInputElement) {
        elInput.checked = true;
    }
}

// ----------------------------------------------------------------------------

export default setSelected;
